export default class tipoFalla{
	constructor($scope,
				$routeParams,
				method,
				tipoFallaService,
				$location,
                $uibModal,
				toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(tipoFallaService);
			break;
			case 'new':
				this.create(tipoFallaService);
			break;
			case 'view':
				this.view($routeParams,
                    tipoFallaService);
			break;
		}
	}

	list(tipoFallaService){

        let self = this.scope;
        tipoFallaService.getAll().then((resp, err) => {
            self.tiposFallas = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.tiposFallas.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, tipoFallaService);
        /*
        this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoFallaService.delete({_id: id}).then((resp) => {
                    if (resp.data.success == true) {
                        this.toastr.success('Tipo de falla eliminada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al eliminar el tipo de falla!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
		*/
	}

	create(tipoFallaService){

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoFallaService.save(this.scope.tipoDeFalla).then((resp) => {
                    this.toastr.success('Tipo de falla creada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/tipo_falla');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear el tipo de falla!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

	view($routeParams,
         tipoFallaService){

		this.scope.aux = {};
        tipoFallaService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.tipoDeFalla = resp.data.message;
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoFallaService.update(this.scope.tipoDeFalla).then((resp) => {
                    this.toastr.success('Tipo de falla modificada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/tipo_falla');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el tipo de falla!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Tipo de Falla</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el Tipo de Falla: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.tiposFallas.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Tipo de falla eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar el Tipo de Falla!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/tipo_falla/tipo_falla.js